import { BrowserRouter } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import ErrorBoundary from './components/ErrorBoundary';
import RouteSeoHead from './components/RouteSeoHead';
import ScrollToTop from './components/ScrollToTop';
import AppRoutes from './AppRoutes';
import { CurrencyProvider } from './contexts/CurrencyContext';

export default function App() {
  return (
    <ErrorBoundary>
      <CurrencyProvider>
      <BrowserRouter>
        <RouteSeoHead />
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
      </CurrencyProvider>
      <Analytics />
      <SpeedInsights />
    </ErrorBoundary>
  );
}
